<template>
    <div class="popup type2" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>회원 아이디 찾기</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <template v-if="idList.length > 1">
                        <p class="popup__info-tit">가입하신 아이디가 <span class="c-blue">{{ idList.length }}건</span> 조회되었습니다.</p>
                        <ul class="id-result-list">
                            <li v-for="(id, idx) in idList" :key="idx">
                                <span class="id-result-list__num">{{ idx + 1 }}</span>
                                <span class="id-result-list__id">{{ id }}</span>
                            </li>
                        </ul>
                    </template>
                    <p class="popup__info-tit" v-else>가입하신 아이디는 <span class="c-blue">{{ idText }}</span> 입니다.</p>
                    <div class="botton-wrap">
                        <a href="javascript:;" class="main-button c-main" @click="confirm">확인</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false,
                idList: [],
            }
        },
        computed: {
            idText() {
                return this.idList.join(', ')
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            popupBtn() {
                this.popupShow = !this.popupShow
            },
            confirm(){
                this.popupShow = false
                this.$router.push('/kr/login')
            }
        },
    }
</script>
<style scoped>
.id-result-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
}
.id-result-list li {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 16px;
    background-color: #F5F8FC;
    border-radius: 8px;
}
.id-result-list__num {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    border-radius: 50%;
    background-color: var(--point-blue);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}
.id-result-list__id {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}
</style>